/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PdpRespSidebarBlurbs_sku = {
    readonly " $fragmentRefs": FragmentRefs<"PdpRespSidebarBlurbShipping_sku">;
    readonly " $refType": "PdpRespSidebarBlurbs_sku";
};
export type PdpRespSidebarBlurbs_sku$data = PdpRespSidebarBlurbs_sku;
export type PdpRespSidebarBlurbs_sku$key = {
    readonly " $data"?: PdpRespSidebarBlurbs_sku$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpRespSidebarBlurbs_sku">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "PdpRespSidebarBlurbs_sku",
  "type": "ItemSkuType",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "PdpRespSidebarBlurbShipping_sku",
      "args": null
    }
  ]
};
(node as any).hash = 'ab880705901c8a3f8f1fc7e636d32f2c';
export default node;
